import { AssigneeOptionVariant } from '@shared/components/dropdown-chip/DropdownChip';
import { makeRootClassName, StyleProps } from '@shared/utils';
import clsx from 'clsx';
import { capitalize } from 'lodash';
import { ReactElement } from 'react';

export type TextChipProps = StyleProps & {
  text: string;
  variant?: AssigneeOptionVariant | 'CUSTOM';
  shouldCapitalize?: boolean;
};

const ROOT = makeRootClassName('TextChip');

const DEFAULT_PROPS = {
  shouldCapitalize: true,
} as const;

function TextChip(props: TextChipProps): ReactElement {
  const p = { ...DEFAULT_PROPS, ...props };

  const variantClass =
    p.variant === 'CUSTOM'
      ? ''
      : `variant-${AssigneeOptionVariant[p.variant || 0]}`;
  return (
    <div className={clsx(`${ROOT}`, p.className, variantClass)}>
      {p.shouldCapitalize ? capitalize(p.text) : p.text}
    </div>
  );
}

export default TextChip;
